export interface ApiError {
  message: string
  location?: string
}

export interface ApiErrors {
  errors: ApiError[]
}

export function isApiErrors(error: unknown): error is ApiErrors {
  return (
    typeof error === 'object' &&
    error != null &&
    'errors' in error &&
    Array.isArray(error.errors) &&
    error.errors.every((errorItem) => typeof errorItem === 'object' && errorItem != null && 'message' in errorItem && typeof errorItem.message === 'string')
  )
}
